import { render, staticRenderFns } from "./attribute-element.vue?vue&type=template&id=529adc6d&"
import script from "./attribute-element.vue?vue&type=script&lang=js&"
export * from "./attribute-element.vue?vue&type=script&lang=js&"
import style0 from "./attribute-element.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports